import EntryPoint from './Pages/App/index';
import ThemeProvider from './Utils/themeProvider';
import { SnackbarProvider } from 'notistack';

import './App.css';
function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <SnackbarProvider>
          <EntryPoint />
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
